import { emptyPicklistQueryResponse, PicklistQueryResponse } from "../Core/Picklists/PicklistTypes";
import { CandyThunkAction } from "../Core/Store/CandyReduxTypes";
import { DigestQueryFilter } from "../../../../Common/CandyApiClient/DigestApiClient/Types/DigestQueryFilter";
import { GetByInnResponseInfo } from "../../../../Common/CandyApiClient/Types/Focus/FocusTypes";
import { PicklistSourceId } from "../Core/Picklists/IPicklistsProvider";
import { getCandyHub } from "../../Forms/Sentry/InitializeSentry";

export function queryPicklistAction(
    source: PicklistSourceId,
    picklistFilter?: DigestQueryFilter
): CandyThunkAction<Promise<PicklistQueryResponse>> {
    return async (_, __, form) => {
        try {
            return form.picklistsProvider.getPicklist(source)?.query(picklistFilter) ?? emptyPicklistQueryResponse();
        } catch (e) {
            getCandyHub().captureException(e);
        }

        return emptyPicklistQueryResponse();
    };
}

export function getOrganizationNameByInnAction(inn: string): CandyThunkAction<Promise<GetByInnResponseInfo>> {
    return (_, __, form) => form.focusProvider.getOrganizationNameByInn(inn);
}
